(() => {
  'use strict';
  const root = document.getElementById('dac-list-undo');
  if (!root || window.DACListUndo) return;
  const words = JSON.parse(root.querySelector('[data-undo-copy]').textContent);
  const scope = root.dataset.scope;
  const storageKey = 'dac:list-undo:v1:' + scope;
  const rows = root.querySelector('[data-undo-rows]');
  const panel = root.querySelector('[data-undo-panel]');
  const launcher = root.querySelector('[data-undo-launcher]');
  const announcer = document.querySelector('[data-undo-status]');
  const nodes = new Map();
  const graceMs = 3000;
  let entries = [], timer, last = performance.now(), paused = false, busy = false;
  const identity = entry => entry.kind === 'purchased' ? 'p:' + entry.sku : 'w:' + entry.lid + ':' + entry.item.epi;
  const valid = entry => entry && ['purchased', 'wishlist'].includes(entry.kind) &&
    typeof entry.id === 'string' && typeof entry.title === 'string' && entry.title.length <= 500 &&
    Number.isFinite(entry.remaining) && entry.remaining >= 0 && entry.remaining <= 30000 &&
    Number.isFinite(entry.created) && Date.now() - entry.created < 86400000 &&
    (entry.kind === 'purchased' ? typeof entry.sku === 'string' && entry.sku.length < 256 :
      typeof entry.lid === 'string' && entry.item && /^\d+$/.test(String(entry.item.epi)) && /^\d+$/.test(String(entry.item.empi)));
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) entries = saved.filter(valid).slice(0, 50).map(entry => ({ ...entry,
      remaining: Math.min(entry.remaining, graceMs), state: entry.state === 'waiting' ? 'waiting' : 'uncertain' }));
  } catch (_) {}
  function save() {
    try { sessionStorage.setItem(storageKey, JSON.stringify(entries)); return true; }
    catch (_) { return false; }
  }
  function emit(entry, outcome) {
    document.dispatchEvent(new CustomEvent('dac:list-change', { detail: { entry: { ...entry }, outcome } }));
  }
  function announce(message) { announcer.textContent = message; }
  function remove(entry, outcome) {
    entries = entries.filter(item => item !== entry); save(); render(); emit(entry, outcome);
  }
  function copy(entry) {
    return words.removed.replace('[kit]', entry.title).replace('[list]', entry.kind === 'purchased' ? words.purchased : entry.listName || words.wishlist);
  }
  function render() {
    root.hidden = !entries.length;
    for (const [id, node] of nodes) if (!entries.some(entry => entry.id === id)) { node.remove(); nodes.delete(id); }
    entries.forEach(entry => {
      let row = nodes.get(entry.id);
      if (!row) {
        row = document.createElement('li'); row.className = 'dac-list-undo__row';
        const body = document.createElement('div');
        const status = document.createElement('p'); status.className = 'dac-list-undo__status';
        const message = document.createElement('p'); message.className = 'dac-list-undo__message';
        const detail = document.createElement('p'); detail.className = 'dac-list-undo__detail';
        const action = document.createElement('button'); action.type = 'button'; action.className = 'dac-list-undo__action';
        body.append(status, message, detail); row.append(body, action); rows.append(row); nodes.set(entry.id, row);
        row._status = status; row._message = message; row._detail = detail; row._action = action;
        action.onclick = () => {
          if (entry.state === 'waiting') {
            const hadFocus = row.contains(document.activeElement);
            remove(entry, 'undone'); announce(words.restored.replace('[kit]', entry.title));
            if (hadFocus) {
              const next = rows.querySelector('button') || document.querySelector('main h1, h1');
              if (next) { if (next.tagName === 'H1') next.tabIndex = -1; next.focus({ preventScroll: true }); }
            }
          } else if (entry.state !== 'saving') {
            const url = new URL(window.Shopify.routes.root + 'pages/' + (entry.kind === 'purchased' ? 'already-purchased' : 'wishlist'), location.origin);
            if (entry.kind === 'wishlist') url.searchParams.set('lid', entry.lid);
            if (window.Shopify.theme.role === 'unpublished') url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
            remove(entry, 'check'); location.assign(url.href);
          }
        };
      }
      row._message.textContent = entry.title;
      row._status.textContent = entry.state === 'uncertain' ? words.recent : copy(entry).replace('“' + entry.title + '” ', '');
      row._detail.textContent = entry.state === 'waiting' ? (entry.remaining ? words.grace.replace('[seconds]', String(Math.ceil(entry.remaining / 1000))) : words.waiting) :
        entry.state === 'saving' ? words.saving : words.uncertain;
      row._action.textContent = entry.state === 'waiting' ? words.undo : words.check;
      row._action.setAttribute('aria-label', (entry.state === 'waiting' ? words.undo : words.check) + ': ' + entry.title);
      row._action.disabled = entry.state === 'saving';
      row.dataset.state = entry.state;
    });
    launcher.textContent = words.recent + ' (' + entries.length + ')';
    launcher.setAttribute('aria-expanded', String(!panel.hidden));
    if (!entries.length) { clearTimeout(timer); timer = undefined; }
  }
  function request(call) {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject(new Error('unconfirmed')), 20000);
      const finish = fn => value => { clearTimeout(timeout); fn(value); };
      try { call(finish(resolve), finish(reject)); } catch (error) { clearTimeout(timeout); reject(error); }
    });
  }
  async function commit(entry) {
    if (busy || entry.state !== 'waiting' || document.hidden) return;
    if (entry.kind === 'purchased' && !window.ALPManager?.auth_token) return;
    if (entry.kind === 'wishlist' && !window._swat?.deleteFromList) return;
    busy = true; entry.state = 'saving'; save(); render();
    try {
      if (entry.kind === 'purchased') {
        const manager = window.ALPManager;
        if (String(manager._customerId) !== root.dataset.customer) throw new Error('identity changed');
        const response = await request((yes, no) => manager.fetch('/api/update_purchased?shop=' + encodeURIComponent(manager.shop), {
          method: 'POST', body: JSON.stringify({ sku: entry.sku, purchased: false, country: window.Shopify.country || 'US' })
        }).then(yes, no));
        if (!Array.isArray(response?.new_value)) throw new Error('unconfirmed');
        window.dispatchEvent(new CustomEvent('alp-manager-skus-updated', { detail: response.new_value }));
        window.deleteAlreadyPurchased?.();
      } else {
        if (root.dataset.customer && String(window.swymCustomerId || '') !== root.dataset.customer) throw new Error('identity changed');
        await request((yes, no) => window._swat.deleteFromList(entry.lid, entry.item, yes, no));
        try { window._swat.wishlistCount?.(count => {
          if (!Number.isFinite(Number(count))) return;
          document.querySelectorAll('.header-icon__wishlist-counter, .header-icon__wishlist-counter-mobile').forEach(node => {
            node.textContent = count; node.classList.toggle('hidden', Number(count) === 0);
          });
        }); } catch (_) {}
      }
      remove(entry, 'saved'); announce(words.saved.replace('[kit]', entry.title));
    } catch (_) {
      entry.state = 'uncertain'; save(); render(); emit(entry, 'uncertain'); announce(words.uncertain);
    } finally { busy = false; }
  }
  function tick() {
    timer = undefined;
    const now = performance.now(), elapsed = Math.min(1000, Math.max(0, now - last)); last = now;
    const modalOpen = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(node => !node.hidden && node.getClientRects().length);
    if (!document.hidden && !paused && !modalOpen && !root.contains(document.activeElement)) {
      entries.filter(entry => entry.state === 'waiting').forEach(entry => { entry.remaining = Math.max(0, entry.remaining - elapsed); });
      save(); render();
      const ready = entries.find(entry => entry.state === 'waiting' && !entry.remaining);
      if (ready) commit(ready);
    }
    if (entries.some(entry => entry.state === 'waiting' || entry.state === 'saving')) timer = setTimeout(tick, 250);
  }
  function start() { if (!timer) { last = performance.now(); timer = setTimeout(tick, 250); } }
  function scheduleBatch(inputs) {
    const additions = [];
    inputs.forEach(input => {
      const candidate = { ...input, title: String(input.title || '').split(/\s+-\s+(?=\d+(?:\.\d+)?\s*(?:["″]|in\b|cm\b|x|×))/i)[0],
        lid: input.lid == null ? undefined : String(input.lid), id: 'change-' + Date.now() + '-' + Math.random().toString(36).slice(2),
        remaining: graceMs, created: Date.now(), state: 'waiting' };
      if (!valid(candidate)) throw new Error('Undo unavailable');
      if (![...entries, ...additions].some(entry => identity(entry) === identity(candidate))) additions.push(candidate);
    });
    if (entries.length + additions.length > 50) throw new Error('Undo unavailable');
    if (!additions.length) return false;
    entries.push(...additions);
    if (!save()) { entries.splice(-additions.length); throw new Error('Undo storage unavailable'); }
    panel.hidden = false; launcher.hidden = true; render(); announce(additions.map(copy).join(' ') + ' ' + words.undo);
    additions.forEach(candidate => emit(candidate, 'pending')); start(); return true;
  }
  function schedule(input) { return scheduleBatch([input]); }
  window.DACListUndo = {
    schedule, scheduleBatch,
    cancel: (kind, key, variant) => { const entry = entries.find(e => e.state === 'waiting' && e.kind === kind && (kind === 'purchased' ? e.sku === key : e.lid === String(key) && String(e.item.epi) === String(variant))); if (entry) { remove(entry, 'undone'); announce(words.restored.replace('[kit]', entry.title)); } return !!entry; },
    pending: () => entries.filter(entry => entry.state === 'waiting' || entry.state === 'saving').map(entry => ({ ...entry })),
    has: (kind, key, variant) => entries.some(entry => ['waiting','saving'].includes(entry.state) && entry.kind === kind &&
      (kind === 'purchased' ? entry.sku === key : entry.lid === String(key) && String(entry.item.epi) === String(variant)))
  };
  root.querySelector('[data-undo-close]').onclick = () => {
    panel.hidden = true; launcher.hidden = false; paused = false; render(); launcher.focus({ preventScroll: true });
  };
  launcher.onclick = () => { panel.hidden = false; launcher.hidden = true; render(); rows.querySelector('button')?.focus({ preventScroll: true }); };
  root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') paused = true; });
  root.addEventListener('pointerleave', () => { paused = false; last = performance.now(); });
  root.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) root.querySelector('[data-undo-close]').click(); });
  document.addEventListener('visibilitychange', () => { last = performance.now(); save(); });
  window.addEventListener('pagehide', () => { clearTimeout(timer); timer = undefined; save(); });
  window.addEventListener('pageshow', () => { last = performance.now(); start(); });
  render(); start();
})();
